<template>
  <drag-dialog
    :visible.sync="visible"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <div slot="title" class="dialog-title">
      <div class="title">{{ activeId ? '编辑' : '新增' }}标签模版</div>

      <el-popover placement="bottom-start" title="操作提示" width="400" trigger="hover">
        <i slot="reference" class="el-icon-warning"></i>

        <div class="tips">
          <div>可以点击“选择”按钮选择已有的模版，在其基础上进行修改</div>
          <div>可拖拽左侧打印元素放入上方模版设计器中</div>
          <div>点击已拖入模版设计器中的元素，可以在右侧面板调整对应的位置、宽高、样式等</div>
          <div>下划线请统一拖拽辅助中的“横线”调整生成</div>
        </div>
      </el-popover>
    </div>

    <div class="template-container">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="5" :offset="0">
          <el-radio-group v-model="currentMode" @input="changeMode">
            <el-radio-button v-for="item in modeList" :key="item.type" :label="item.type">
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
          <div id="provider_container" class="hiprint-section left-section"></div>
        </el-col>
        <el-col :span="14" :offset="0" class="center-wrap">
          <div class="cneter-top">
            <div class="template-title"></div>

            <el-button type="warning" size="small" @click="handleChoose">选 择</el-button>

            <el-popconfirm style="margin: 0 10px" title="确认要清空模版内容吗？" @confirm="handleClear">
              <el-button slot="reference" type="danger" size="small">清 空</el-button>
            </el-popconfirm>

            <el-button type="primary" size="small" @click="handlePreview">预 览</el-button>

            <el-popover style="margin: 0 14px" placement="bottom" trigger="click">
              <div class="size-wrap">
                <span>宽：</span>
                <el-input v-model.trim="setWidth" placeholder="" size="small">
                  <template slot="append">mm</template>
                </el-input>
                <span>&nbsp;高：</span>
                <el-input v-model.trim="setHeight" placeholder="" size="small">
                  <template slot="append">mm</template>
                </el-input>
                <el-button type="primary" size="small" @click="handlePaperSize">确认</el-button>
              </div>
              <el-button slot="reference" size="small">纸张大小：{{ paperWidth }}mm，{{ paperHeight }}mm</el-button>
            </el-popover>

            <el-button icon="el-icon-zoom-out" circle @click="handleZoom(false)"></el-button>
            <span class="zoom-text">{{ (zoomValue * 100).toFixed(0) }}%</span>
            <el-button icon="el-icon-zoom-in" circle @click="handleZoom(true)"></el-button>
          </div>

          <div class="hiprint-center">
            <div id="hiprint_printTemplate" class="hiprint-box"></div>
          </div>

          <div class="center-bottom">
            <el-form :model="editForm" ref="editForm" :rules="rules" label-width="80px" :inline="false" size="small">
              <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                <el-col :span="12" :offset="0">
                  <el-form-item label="模版名称" prop="title">
                    <el-input v-model.trim="editForm.title" placeholder="请输入模版名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item label="" prop="isDefault" label-width="0">
                    <el-checkbox v-model="editForm.isDefault" :true-label="1" :false-label="0">设为默认模版</el-checkbox>
                    <span class="form-item-tips">(设置后打印时会优先使用该模版)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24" :offset="0">
                  <el-form-item label="备注" prop="remark">
                    <el-input
                      type="textarea"
                      v-model="editForm.remark"
                      placeholder="请输入模版名称"
                      :rows="1"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="button-wrap"></div>
          </div>
        </el-col>
        <el-col :span="5" :offset="0">
          <div id="PrintElementOptionSetting" class="hiprint-section right-section"></div>
        </el-col>
      </el-row>
    </div>

    <template slot="footer">
      <el-button :loading="saveLoading" type="primary" size="small" @click="handleSave">保 存</el-button>
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>

    <!-- 模版中心选择 -->
    <TemplateCenter :visible.sync="centerVisible" @templateChoose="chooseCallback" />
    <!-- 预览 -->
    <HiprintPreview :visible.sync="previewVisible" previewHtmlId="edit_preview_html" :activeInfo="activeInfo" />
  </drag-dialog>
</template>

<script>
import { hiprint, disAutoConnect } from 'vue-plugin-hiprint';
import { providers, providerList } from '../basisData/printProviders';

disAutoConnect(); // 取消打印自动连接客户端打印机

import { getFormTemplate, editFormTemplate } from '@/api/system';

import HiprintPreview from './HiprintPreview';
import TemplateCenter from './TemplateCenter';

// 调整元素参数 隐藏/显示
hiprint.setConfig({
  panel: {
    supportOptions: [
      {
        name: 'panelPaperRule',
        hidden: true
      },
      {
        name: 'panelPageRule',
        hidden: true
      },
      {
        name: 'firstPaperFooter',
        hidden: true
      },
      {
        name: 'evenPaperFooter',
        hidden: true
      },
      {
        name: 'oddPaperFooter',
        hidden: true
      },
      {
        name: 'lastPaperFooter',
        hidden: true
      },
      {
        name: 'leftOffset',
        hidden: true
      },
      {
        name: 'topOffset',
        hidden: true
      },
      {
        name: 'fontFamily',
        hidden: true
      },
      {
        name: 'orient',
        hidden: true
      },
      {
        name: 'paperNumberDisabled',
        hidden: true
      },
      {
        name: 'paperNumberContinue',
        hidden: true
      },
      {
        name: 'paperNumberFormat',
        hidden: true
      }
    ]
  }
});

export default {
  components: { TemplateCenter, HiprintPreview },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      currentMode: 0,
      modeList: [],
      hiprintTemplate: null,
      setWidth: 0,
      setHeight: 0,
      paperWidth: 0,
      paperHeight: 0,
      zoomValue: 2,
      editForm: {
        id: null,
        title: '',
        remark: '',
        isDefault: 0
      },
      rules: {
        title: [{ required: true, message: '请输入模板名称', trigger: 'blur' }]
      },
      // 模板中心
      centerVisible: false,
      // 预览弹窗
      previewVisible: false,
      activeInfo: {},
      saveLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.buildDesigner();
        if (this.activeId) {
          this.$nextTick(() => {
            this.getDetailData();
          });
        } else {
          this.$nextTick(() => {
            this.modeList = providerList;
            this.$nextTick(() => {
              this.changeMode();
            });
          });
        }
      }
    }
  },
  methods: {
    async getDetailData() {
      const { data } = await getFormTemplate({ id: this.activeId });

      this.editForm = {
        id: data.id,
        title: data.title,
        remark: data.remark,
        isDefault: data.isDefault
      };
      this.currentMode = data.type;
      const provider = providerList[this.currentMode];
      hiprint.init({
        providers: [...providers]
      });
      this.handleClear();
      $('#provider_container').empty();
      hiprint.PrintElementTypeManager.build('#provider_container', provider.value);

      const tempJson = JSON.parse(data.templateCode || '{}');
      const paperWidth = tempJson?.panels?.[0].width || 0;
      const paperHeight = tempJson?.panels?.[0].height || 0;
      this.paperWidth = paperWidth;
      this.paperHeight = paperHeight;
      this.setWidth = paperWidth;
      this.setHeight = paperHeight;

      this.buildDesigner();
      this.$nextTick(() => {
        this.hiprintTemplate.setPaper(paperWidth, paperHeight);
        this.hiprintTemplate.update(tempJson);
      });
    },
    changeMode() {
      let { currentMode } = this;
      let provider = providerList[currentMode];
      console.log('providerList 打印:', providerList);
      hiprint.init({
        providers: [...providers]
      });
      this.handleClear();
      $('#provider_container').empty();
      this.$refs.editForm.resetFields();
      hiprint.PrintElementTypeManager.build('#provider_container', provider.value);
      this.paperWidth = provider.width;
      this.paperHeight = provider.height;
      this.setWidth = provider.width;
      this.setHeight = provider.height;
      this.hiprintTemplate.setPaper(provider.width, provider.height);
    },
    // 构建设计器
    buildDesigner() {
      // eslint-disable-next-line no-undef
      $('#hiprint_printTemplate').empty(); // 先清空, 避免重复构建
      this.hiprintTemplate = new hiprint.PrintTemplate({
        settingContainer: '#PrintElementOptionSetting' // 元素参数容器
      });

      this.hiprintTemplate.addPrintPanel({
        width: 45,
        height: 10,
        paperNumberDisabled: true,
        paperNumberFormat: ' '
      });
      // 构建 并填充到 容器中
      this.hiprintTemplate.design('#hiprint_printTemplate');
      this.hiprintTemplate.zoom(2);
    },
    // 打印纸张区域大小
    handlePaperSize() {
      const { setWidth, setHeight } = this;
      this.paperWidth = setWidth;
      this.paperHeight = setHeight;

      if (this.hiprintTemplate) {
        this.hiprintTemplate.setPaper(setWidth, setHeight);
      }
    },
    // 缩放模版大小
    handleZoom(up) {
      let zoomValue = this.zoomValue;
      if (up) {
        zoomValue += 0.1;
        if (zoomValue > 5) zoomValue = 5;
      } else {
        zoomValue -= 0.1;
        if (zoomValue < 0.5) zoomValue = 0.5;
      }
      if (this.hiprintTemplate) {
        this.hiprintTemplate.zoom(zoomValue);
        this.zoomValue = zoomValue;
      }
    },
    // 清空模版内容
    handleClear() {
      this.hiprintTemplate.clear();
    },
    // 选择模板
    handleChoose() {
      this.centerVisible = true;
    },
    chooseCallback(tData) {
      const tempJson = JSON.parse(tData.templateCode || '{}');
      this.hiprintTemplate.update(tempJson);
    },
    // 编辑模版 获取模版信息赋值
    async setEditForm(id) {
      const { data } = await getFormTemplate({ id });

      this.editForm = {
        id: data.id,
        title: data.title,
        remark: data.remark,
        isDefault: data.isDefault
      };

      const tempJson = JSON.parse(data.templateCode || '{}');
      this.hiprintTemplate.update(tempJson);
    },
    // 打印预览
    handlePreview() {
      const { currentMode } = this;
      const provider = providerList[currentMode];
      const templateJson = this.hiprintTemplate.getJson();

      this.activeInfo = { ...provider, templateCode: JSON.stringify(templateJson) };
      this.previewVisible = true;
    },
    // 保存
    handleSave() {
      const printJson = JSON.stringify(this.hiprintTemplate.getJson() || {});

      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.saveLoading = true;

          try {
            await editFormTemplate({
              ...this.editForm,
              type: 1,
              templateCode: printJson,
              templateCode: printJson
            });

            this.handleClear();
            this.$refs.editForm.resetFields();

            if (this.editForm.id) {
              this.$message.success('编辑成功!');
            } else {
              this.$message.success('保存成功!');
            }
            this.$emit('update:visible', false);
            this.$emit('refresh');
          } finally {
            this.saveLoading = false;
          }
        } else {
          this.$message.error('请填写必填项');
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style>
/* 自定义 provider 构建样式 */
.left-section .hiprint-printElement-type {
  display: block;
}
.left-section .hiprint-printElement-type {
  padding: 0 0 0 0;
  list-style: none;
}
.left-section .hiprint-printElement-type > li > .title {
  display: block;
  padding: 4px 0px;
  color: #595959;
  font-size: 16px;
  font-weight: 700;
  clear: both;
}
.left-section .hiprint-printElement-type > li > ul {
  padding: 0 0 0 0;
  display: block;
  list-style: none;
}
.left-section .hiprint-printElement-type > li > ul > li {
  display: block;
  float: left;
  width: 100px;
  margin: 0 10px 10px 0;
}
.left-section .hiprint-printElement-type > li > ul > li > a {
  padding: 6px;
  font-size: 12px;
  color: #ffffff;
  text-decoration: none;
  background: #1296db;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
}
</style>

<style lang="scss" scoped>
.dialog-title {
  display: flex;
  align-items: center;

  .title {
    font-size: 20px;
    color: #fff;
  }
  .el-icon-warning {
    margin-left: 2px;
    font-size: 20px;
    color: #d1d1d1;
  }
}

.template-container {
  width: 100%;
  height: 100%;

  > .el-row {
    width: 100%;
    height: 100%;

    .el-col {
      height: 100%;
    }
  }
}

.zoom-text {
  margin: 0 10px;
}

.center-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.hiprint-center {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  padding-top: 30px;
  padding-left: 20px;
  overflow: auto;
}

.tips {
  margin: 0 0 10px;
  padding-bottom: 10px;
  font-size: 14px;
  line-height: 1.5;

  > div {
    position: relative;
    padding-left: 10px;

    &::after {
      position: absolute;
      content: '';
      left: 0;
      top: 8px;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      background-color: #dddddd;
    }
  }
}

.form-item-tips {
  margin-left: 6px;
  font-size: 12px;
  color: #666;
}

.hiprint-section {
  overflow: auto;
  padding: 10px;
  border: 1px solid #ddd;
}
.left-section {
  height: calc(100% - 40px);
  margin-top: 8px;
}
.right-section {
  height: 100%;
}

.button-wrap {
  display: flex;
  justify-content: flex-end;
}

.size-wrap {
  display: flex;
  align-items: center;
  .el-input {
    width: 150px;
  }
  .el-button {
    margin-left: 10px;
  }
}
</style>
